module.exports = __webpack_public_path__ + "static/media/vit_logo.e6204744.png";